import { reports } from "./reports";

export const reserveV2 = {
	title: "Configurações de reserva",
	description:
		"Descrição sucinta da página com até 100 caracteres. Não alterar tamanho desse campo.",
	mainTabs: {
		management: "Gestão",
		reports: "Relatórios",
		configurations: "Configurações",
		loading: "Carregando...",
		disabledTooltip: "Configure as regras de reserva primeiro",
	},
	sideMenu: {
		title: "Configurações de reserva",
		reserveRules: {
			title: "Regras de reservas",
			description: "Configure janela de intervalo e tolerância",
		},
		roomsAndSchedule: {
			title: "Salões & grade horária",
			description: "Crie e edite salões, grade horária e mesas para reservas",
		},
		shifts: {
			title: "Turnos",
			description: "Configure turnos para facilitar operação de reservas",
		},
		specialDates: {
			title: "Datas especiais",
			description: "Configure datas com horários diferenciados",
			emptyState: {
				title: "Ainda não tem nada por aqui",
				description:
					"Configure datas em que o horário funcionará de forma diferente do padrão",
			},
			loading: "Carregando datas especiais...",
			error: "Erro ao carregar datas especiais:",
			newDateButton: "Nova data",
			filters: {
				roomPlaceholder: "Filtrar por salão",
				allRooms: "Todos os salões",
				periodPlaceholder: "Filtrar por período",
				today: "Hoje",
				thisWeek: "Esta semana",
				thisMonth: "Este mês",
				thisQuarter: "Este trimestre",
			},
			table: {
				date: "Data",
				title: "Título",
				startTime: "Horário de início",
				endTime: "Horário de término",
				room: "Salão",
			},
			actions: {
				edit: "Editar",
				delete: "Excluir",
			},
			notifications: {
				deleted: {
					title: "Data especial deletada",
					message: "A data especial foi removida com sucesso.",
				},
				deleteError: {
					title: "Houve algum problema",
					message:
						"Não foi possível deletar a data especial. Tente novamente mais tarde.",
				},
			},
			drawer: {
				newTitle: "Nova data especial",
				editTitle: "Editar data especial",
				buttons: {
					close: "Fechar",
					create: "Criar data especial",
					update: "Atualizar data especial",
					creating: "Criando...",
					updating: "Atualizando...",
				},
			},
			form: {
				titleLabel: "Título",
				titlePlaceholder: "Ex: Noite de Sabores do Mundo",
				dateLabel: "Data",
				datePlaceholder: "Selecione a data",
				allDaySwitch: "Marcar o dia inteiro",
				startTimeLabel: "Horário de início",
				endTimeLabel: "Horário de término",
				roomLabel: "Salão",
				roomPlaceholder: "Selecione um ou mais salões para esta data especial",
				validation: {
					titleRequired: "Por favor, informe um título",
					dateRequired: "Por favor, selecione uma data",
					startTimeRequired: "Por favor, informe o horário de início",
					endTimeRequired: "Por favor, informe o horário de término",
					roomRequired: "Por favor, selecione pelo menos um salão",
					invalidDate: "Data inválida",
					validationTitle: "Validação",
				},
			},
		},
		blockedDates: {
			title: "Datas bloqueadas",
			description: "Configure datas em que o local ou salão não abrirá",
			emptyState: {
				title: "Ainda não tem nada por aqui",
				description: "Configure datas em que o local ou salão não abrirá",
			},
			loading: "Carregando datas bloqueadas...",
			error: "Erro ao carregar datas bloqueadas:",
			newDateButton: "Nova data",
			allDay: "Dia inteiro",
			filters: {
				roomPlaceholder: "Filtrar por salão",
				allRooms: "Todos os salões",
				periodPlaceholder: "Filtrar por período",
				today: "Hoje",
				thisWeek: "Esta semana",
				thisMonth: "Este mês",
				thisQuarter: "Este trimestre",
			},
			table: {
				date: "Data",
				title: "Título",
				startTime: "Horário de início",
				endTime: "Horário de término",
				room: "Salão",
			},
			actions: {
				edit: "Editar",
				delete: "Excluir",
			},
			notifications: {
				deleted: {
					title: "Data bloqueada deletada",
					message: "A data bloqueada foi removida com sucesso.",
				},
				deleteError: {
					title: "Houve algum problema",
					message:
						"Não foi possível deletar a data bloqueada. Tente novamente mais tarde.",
				},
			},
			drawer: {
				newTitle: "Nova data bloqueada",
				editTitle: "Editar data bloqueada",
				buttons: {
					close: "Fechar",
					create: "Criar novo bloqueio",
					update: "Atualizar data bloqueada",
					creating: "Criando...",
					updating: "Atualizando...",
				},
			},
			form: {
				titleLabel: "Título",
				titlePlaceholder: "Ex: Manutenção programada",
				dateLabel: "Data",
				datePlaceholder: "Selecione a data",
				allDaySwitch: "Marcar o dia inteiro",
				startTimeLabel: "Horário de início",
				endTimeLabel: "Horário de término",
				roomLabel: "Salão",
				roomPlaceholder: "Selecione um ou mais salões para bloquear reserva na data",
				validation: {
					titleRequired: "Por favor, informe o título",
					dateRequired: "Por favor, selecione uma data",
					roomRequired: "Por favor, selecione pelo menos um salão",
					invalidDate: "Data inválida",
					validationTitle: "Validação",
				},
			},
		},
		communication: {
			title: "Comunicação",
			description: "Ative ou desative o envio de mensagens",
			headerTitle: "Enviar SMS para clientes",
			loading: "Carregando...",
			alert: {
				costInfo: "As mensagens enviadas têm um custo de {{cost}}/envio.",
			},
			fields: {
				reminder: "Primeiro contato",
				confirmation: "Confirmação da reserva",
				dayOf: "No dia da reserva",
				late: "Atrasado",
			},
			buttons: {
				discard: "Descartar alterações",
				save: "Salvar alterações",
				saving: "Salvando...",
			},
		},
	},
	roomsContent: {
		title: "Salões",
		newRoomButton: "Novo salão",
		roomName: "Nome do salão",
		roomId: "ID do salão",
	},
	shifts: {
		title: "Turnos",
		newShiftButton: "Novo turno",
		editShiftLabel: "Editar turno",
		deleteShiftLabel: "Deletar turno",
		breakfast: "Café da manhã",
		lunch: "Almoço",
		dinner: "Jantar",
		emptyState: {
			title: "Ainda não tem nada por aqui",
			description: "Crie um novo turno para facilitar a gestão das reservas na operação",
		},
	},
	newShiftDrawer: {
		title: "Novo turno",
		shiftNameLabel: "Nome do turno",
		shiftNamePlaceholder: "Digite o nome do turno",
		startTimeLabel: "Horário de início",
		endTimeLabel: "Horário de fim",
		buttons: {
			close: "Fechar",
			create: "Criar turno",
		},
		errors: {
			required: "Este campo é obrigatório",
		},
	},
	roomsAndSchedule: {
		title: "Salões",
		newRoomButton: "Novo salão",
		days: {
			sunday: "Domingo",
			monday: "Segunda",
			tuesday: "Terça",
			wednesday: "Quarta",
			thursday: "Quinta",
			friday: "Sexta",
			saturday: "Sábado",
		},
		dayInitials: {
			sunday: "D",
			monday: "S",
			tuesday: "T",
			wednesday: "Q",
			thursday: "Q",
			friday: "S",
			saturday: "S",
		},
		timeFormat: "{{startTime}} às {{endTime}}",
		loading: "Carregando salões...",
		loadingSchedules: "Carregando horários...",
		error: "Erro ao carregar salões:",
		menuItems: {
			showSchedule: "Mostrar grade horária",
			hideSchedule: "Esconder grade horária",
			editRoom: "Editar salão",
			deleteRoom: "Excluir salão",
		},
		notifications: {
			roomDeleted: {
				title: "Salão deletado com sucesso",
				message: "O salão foi removido com sucesso.",
			},
			roomDeleteError: {
				title: "Houve algum problema",
				message: "Erro ao deletar salão.",
			},
			loadSchedulesError: {
				title: "Erro ao carregar",
				message: "Erro ao carregar horários do salão.",
			},
			roomCreated: {
				title: "Salão criado com sucesso",
				message: "O salão foi criado com sucesso.",
			},
			roomCreateError: {
				title: "Erro ao criar",
				message: "Erro ao criar salão. Tente novamente.",
			},
			schedulesError: {
				title: "Houve algum problema",
				message:
					"Salão criado, mas houve erro ao criar os horários. Por favor, adicione-os manualmente.",
			},
		},
		creatingRoom: "Criando salão...",
		creatingSchedules: "Criando horários...",
		emptyState: {
			title: "Ainda não tem nada por aqui",
			description: "Crie um novo salão para permitir que os seus clientes façam reservas",
			noSettingsTitle: "Configure as regras de reserva primeiro",
			noSettingsDescription:
				"Você precisa configurar as regras de reserva antes de criar salões e grade horária",
			actionButton: "Configurar regras de reserva",
		},
	},
	newRoomDrawer: {
		title: "Novo salão",
		editTitle: "Editar salão",
		buttons: {
			close: "Fechar",
			createRoom: "Criar salão",
			saveChanges: "Salvar alterações",
		},
		sideMenu: {
			configSection: "Config do salão",
			roomData: "Dados do salão",
			schedulesByDay: "Horários por dia",
		},
		form: {
			roomDataTitle: "Dados do salão",
			roomName: {
				label: "Nome do salão",
				placeholder: "Digite o nome do salão",
			},
			roomCapacity: {
				label: "Capacidade do salão por horário",
				placeholder: "Digite a capacidade do salão",
			},
			activateRoom: "Ativar salão para reservas",
			importSchedule: "Importar grade horária de outro dia ou salão",
		},
		replicateScheduleLabel: "Replicar grade horária para outros dias da semana",
		importScheduleLabel: "Importar grade horária de outro dia ou salão",
		days: {
			sunday: "Domingo",
			monday: "Segunda",
			tuesday: "Terça",
			wednesday: "Quarta",
			thursday: "Quinta",
			friday: "Sexta",
			saturday: "Sábado",
		},
		notifications: {
			roomUpdated: {
				title: "Salão atualizado com sucesso",
				message: "O salão foi atualizado com sucesso.",
			},
			roomUpdateError: {
				title: "Houve algum problema",
				message: "Não conseguimos salvar as alterações. Tente novamente mais tarde.",
			},
			scheduleError: {
				title: "Houve algum problema",
				message: "Salão atualizado, mas houve erro ao salvar alguns horários.",
			},
		},
		dayScheduleView: {
			schedulesTitle: "Horários de {{day}}",
			emptyState: "Nenhum horário cadastrado",
			newScheduleButton: "Novo horário",
		},
		newScheduleModal: {
			title: "Novo horário",
			editTitle: "Editar horário",
			startTimeLabel: "Horário de início",
			endTimeLabel: "Horário de fim",
			scaleLabel: "Escala (minutos)",
			scalePlaceholder: "Selecione a escala",
			scaleOptions: {
				minutes15: "15 minutos",
				minutes30: "30 minutos",
				minutes45: "45 minutos",
				minutes60: "60 minutos",
			},
			buttons: {
				cancel: "Cancelar",
				save: "Salvar",
			},
			errors: {
				startTimeRequired: "Horário de início é obrigatório",
				endTimeRequired: "Horário de fim é obrigatório",
				endTimeAfterStart: "O horário de fim precisa ser após o horário de início",
				scaleRequired: "Escala é obrigatória",
				scaleInvalid: "A escala deve ser 15, 30, 45 ou 60 minutos",
			},
		},
	},
	reserveRulesContent: {
		loading: "Carregando configurações...",
		errorLoading: "Erro ao carregar configurações:",
		sections: {
			generalRules: "Regras gerais",
			reservationParameters: "Parâmetros da reserva",
			customerSite: "Site do cliente",
		},
		fields: {
			calendarWindow: {
				label: "Janela de intervalo no calendário",
				placeholder: "Digite os dias de intervalo",
				tooltip: "Tempo em dias para o futuro em que suas reservas estarão abertas.",
			},
			delayTolerance: {
				label: "Tolerância limite de atrasos",
				placeholder: "Digite a tolerância limite em...",
				tooltip: "Tempo em minutos em que as reservas serão automaticamente canceladas.",
			},
			peopleLimit: {
				label: "Limite de pessoas por reserva",
				placeholder: "Digite a quantidade máxima d...",
				tooltip: "Quantidade máxima de pessoas permitida por reserva",
			},
			rulesAndConditions: {
				label: "Regras e condições de reserva",
				placeholder:
					"Digite as regras e condições de reserva que serão mostradas no momento da reserva do cliente",
			},
		},
		switches: {
			autoConfirm: {
				label: "Confirmação automática de reserva",
				description:
					"Seus clientes terão suas solicitações de reserva confirmadas automaticamente.",
			},
			requireCPF: {
				label: "CPF obrigatório",
				description:
					"No momento da reserva, o cliente só consegue avançar se fornecer um CPF válido",
			},
			requireBirthDate: {
				label: "Data de aniversário obrigatória",
				description:
					"No momento da reserva, o cliente só consegue avançar se preencher a data de nascimento",
			},
		},
		imageUpload: {
			label: "Imagem do site",
			tooltip: "Faça o upload da imagem que será utilizada no site.",
			alt: "Imagem do site",
			changeImage: "Alterar imagem",
			addImage: "Adicionar imagem",
			hint: "Tipo de arquivo .png, .jpg e .jpeg até 1MB",
		},
		siteUrl: {
			label: "Site para reservas",
			placeholder: "nomedorestaurante",
		},
		buttons: {
			discardChanges: "Descartar alterações",
			saveChanges: "Salvar alterações",
			createSettings: "Criar configurações",
			saving: "Salvando...",
		},
		notifications: {
			invalidFileType: {
				title: "Tipo de arquivo inválido",
				message: "Por favor, selecione uma imagem nos formatos .jpg, .jpeg ou .png.",
			},
			fileTooLarge: {
				title: "Arquivo muito grande",
				message:
					"O arquivo selecionado excede o limite de 1MB. Por favor, selecione uma imagem menor.",
			},
			saveSuccess: {
				title: "Alterações salvas com sucesso",
				message: "As alterações de regras do salão foram salvas com sucesso.",
			},
			saveError: {
				title: "Houve algum problema",
				message: "Não conseguimos salvar as alterações. Tente novamente mais tarde",
			},
		},
	},
	configurations: {
		title: "Configurações",
		description: "Configure as regras e horários das suas reservas",
	},
	management: {
		title: "Reservas",
		description: "Faça a gestão das suas reservas",
		editReservationsButton: "Editar reservas em massa",
		addReservationButton: "Adicionar reserva",
		todayLabel: "Hoje",
		confirmedLabel: "Confirmados",
		cancelledLabel: "Cancelados",
		waitingConfirmationLabel: "Aguardando confirmação",
		forecastLabel: "Previsão",
		peopleLabel: "pessoas",
		remainingReservationsLabel: "Reservas restantes no mês",
		upcomingSpecialDatesLabel: "Próximas datas especiais",
		tabs: {
			all: "Todas",
			received: "Recebidas",
			accommodated: "Acomodados",
			cancelled: "Canceladas",
		},
		statusTags: {
			waitingConfirmation: "aguardando confirmação",
			confirmed: "confirmada",
			delayed: "atrasado",
			accommodated: "acomodado",
			cancelled: "cancelada",
		},
		notifications: {
			reservationCreated: {
				title: "Reserva criada com sucesso",
				message: "A reserva foi criada com sucesso",
			},
			reservationCreatedError: {
				title: "Erro ao criar reserva",
				message: "Ocorreu um erro ao tentar criar a reserva. Tente novamente.",
			},
			reservationConfirmed: {
				title: "Reserva confirmada",
				message: "A reserva foi confirmada com sucesso",
			},
			reservationConfirmedError: {
				title: "Erro ao confirmar reserva",
				message: "Ocorreu um erro ao tentar confirmar a reserva",
			},
			reservationCancelled: {
				title: "Reserva cancelada",
				message: "A reserva foi cancelada com sucesso",
			},
			reservationCancelledError: {
				title: "Erro ao cancelar reserva",
				message: "Ocorreu um erro ao tentar cancelar a reserva",
			},
			reservationAccommodated: {
				title: "Reserva acomodada",
				message: "A reserva foi acomodada com sucesso",
			},
			reservationAccommodatedError: {
				title: "Erro ao acomodar reserva",
				message: "Ocorreu um erro ao tentar acomodar a reserva",
			},
			reservationLateSmsSent: {
				title: "SMS de atraso enviado",
				message: "O SMS de atraso foi enviado para o cliente",
			},
		},
		bulkActions: {
			selectedCount: "{{count}} selecionados",
			selectAll: "Selecionar todos ({{count}})",
			confirmReservations: "Confirmar reservas",
			cancelReservations: "Cancelar reservas",
		},
		createReservationDrawer: {
			title: "Criar reserva",
			editTitle: "Editar reserva",
			labels: {
				peopleCount: "Quantidade de pessoas",
				dateTime: "Data e hora da reserva",
				room: "Salão",
				name: "Nome completo",
				document: "CPF",
				phone: "Celular",
				birthDate: "Data de nascimento",
				occasion: "Ocasião",
				observations: "Observações",
			},
			placeholders: {
				peopleCount: "Selecione a quantidade de pessoas",
				dateTime: "Selecione a data e horário",
				room: "Selecione o salão",
				name: "Digite o nome do cliente",
				document: "Digite o CPF do cliente",
				phone: "(11) 99999-9999",
				birthDate: "__/__/____",
				occasion: "Escolha uma ocasião (opcional)",
				observations: "Digite uma observação (opcional)",
			},
			buttons: {
				close: "Fechar",
				create: "Criar reserva",
				update: "Salvar",
				creating: "Criando...",
				saving: "Salvando...",
			},
			occasions: {
				birthday: "Aniversário",
				wedding: "Casamento",
				graduation: "Formatura",
				romanticDinner: "Jantar Romântico",
				meeting: "Reunião",
				other: "Outro",
			},
			notifications: {
				validationError: "Erro de validação",
			},
			people: "pessoas",
			person: "pessoa",
			dateTimeFormat: "{{date}} às {{time}}",
		},
		reservationDetailsDrawer: {
			title: "Detalhes da reserva",
			loading: "Carregando...",
			notFound: "Reserva não encontrada",
			createdAt: "Criado em {{date}}",
			labels: {
				observation: "Observação",
				occasion: "Ocasião",
				notInformed: "Não informado",
			},
			actions: {
				close: "Fechar",
				cancel: "Cancelar reserva",
				confirm: "Confirmar reserva",
				accommodate: "Acomodar cliente",
				edit: "Editar",
				editReservation: "Editar reserva",
				editObservation: "Editar observação",
				editOccasion: "Editar ocasião",
			},
			alerts: {
				pending: "Ainda não confirmado",
				confirmedBy: "Confirmado por {{user}} dia {{date}} às {{time}}",
			},
			table: {
				actionHeader: "AÇÃO",
				dateTimeHeader: "DATA E HORA",
				actions: {
					requested: "Reserva solicitada",
					confirmed: "Reserva confirmada",
					accommodated: "Reserva acomodada",
					cancelled: "Reserva cancelada",
					statusChanged: "Status alterado",
					confirmationSms: "SMS de confirmação",
					delaySms: "SMS de atraso",
					cancellationSms: "SMS de cancelamento",
				},
				sendSms: "Enviar SMS",
			},
			places: {
				one: "lugar",
				other: "lugares",
			},
		},
		filters: {
			searchPlaceholder: "Pesquisar reserva",
			statusPlaceholder: "Filtrar por status",
			roomPlaceholder: "Filtrar por salão",
			statusOptions: {
				all: "Todos os status",
				waiting_confirmation: "Aguardando confirmação",
				confirmed: "Confirmadas",
				accommodated: "Acomodadas",
				cancelled: "Canceladas",
			},
			roomOptions: {
				all: "Todos os salões",
			},
		},
	},
	reports,
};
